module.exports = __webpack_public_path__ + "img/wechat.c5d17120.png";